<template>
    <v-layout wrap column class="layout-add layout-add--max_width">
        <v-toolbar text class="v-toolbar--custom">
            <v-toolbar-title>Новый продукт</v-toolbar-title>
            <v-spacer/>
            <v-btn color="info" class="v-btn--save" :loading="loading" :disabled="loading" @click="sendForm">
                Сохранить
                <span slot="loader" class="custom-loader">
					<v-icon light>cached</v-icon>
				</span>
            </v-btn>
        </v-toolbar>

        <v-form class="form-add">
            <v-flex xs12>
                <v-subheader class="pa-0">Название в Horeca</v-subheader>
                <v-text-field
                    ref="product_name"
                    v-model="product.name"
                    v-validate="'required|max:100'"
                    data-vv-name="name"
                    :error-messages="errors.collect('name')"
                    counter="100"
                    single-line
                    text
                    solo
                    required/>
            </v-flex>

            <v-flex v-if="project.iiko_integration" xs12>
                <v-layout>
                    <v-flex xs5>
                        <v-subheader class="pa-0">Iiko id</v-subheader>
                        <v-text-field
                            ref="product_iiko_id"
                            v-model="product.iiko_id"
                            data-vv-name="iiko_id"
                            clearable
                            readonly
                            :error-messages="errors.collect('iiko_id')"
                            single-line
                            text
                            solo/>
                    </v-flex>

                    <v-flex xs6 offset-xs1>
                        <v-subheader class="pa-0">Категория в Iiko</v-subheader>
                        <v-autocomplete
                            v-model="iiko.category"
                            :items="iiko_items"
                            :disabled="iiko.isLoading"
                            :loading="iiko.isLoading"
                            :search-input.sync="iiko.categorySearch"
                            color="black"
                            @change="changeIikoCategory"
                            @click:clear="clearIikoProducts"
                            single-line
                            solo
                            hide-no-data
                            hide-selected
                            item-text="name"
                            item-value="id"
                            clearable
                            :placeholder="iiko.isLoading ? 'Пожалуйста подождите, список подготавливается' : 'Поиск категории по названию'"
                            return-object
                        ></v-autocomplete>

                        <template v-if="iiko.category && items && items.length">
                            <v-subheader class="pa-0">Получение ID продукта из Iiko</v-subheader>
                            <v-autocomplete
                                v-model="iiko.product"
                                :items="items"
                                :search-input.sync="iiko.search"
                                color="black"
                                @change="changeIikoId"
                                class="mt-5 mb-5"
                                single-line
                                solo
                                hide-no-data
                                hide-selected
                                item-text="name"
                                item-value="id"
                                clearable
                                placeholder="Поиск продукта по названию из выбранной категории"
                                return-object
                            ></v-autocomplete>
                        </template>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-flex xs-12>
                <v-layout>
                    <v-flex xs5>
                        <v-subheader class="pa-0">Цена</v-subheader>
                        <v-text-field
                            ref="product_price"
                            v-model="product.price"
                            v-validate="'required'"
                            data-vv-name="price"
                            :error-messages="errors.collect('price')"
                            single-line
                            text
                            solo
                            required
                            suffix="so`m"/>
                    </v-flex>

                    <v-flex xs6 offset-xs1>
                        <v-subheader class="pa-0">Скидка</v-subheader>
                        <v-text-field
                            ref="product_discount"
                            v-model="product.discount"
                            single-line
                            text
                            solo
                            required
                            prefix="%"/>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-flex v-if="project.iiko_integration" xs12>
                <v-layout>
                    <v-flex xs4>
                        <v-checkbox label="Товар на доставку" v-model="product.iiko_delivery_append"/>
                    </v-flex>
                </v-layout>

                <v-layout v-if="product.iiko_delivery_append">
                    <v-flex xs5>
                        <v-subheader class="pa-0">Iiko id упаковки</v-subheader>
                        <v-text-field
                            ref="product_iiko_id"
                            v-model="product.iiko_delivery_id"
                            data-vv-name="iiko_id"
                            clearable
                            readonly
                            :error-messages="errors.collect('iiko_delivery_id')"
                            single-line
                            text
                            solo/>

                        <v-subheader class="pa-0">Цена упаковки</v-subheader>
                        <v-text-field
                            ref="product_price"
                            v-model="product.iiko_delivery_price"
                            v-validate="'required'"
                            data-vv-name="price"
                            :error-messages="errors.collect('iiko_delivery_price')"
                            single-line
                            text
                            solo
                            required
                            suffix="so`m"/>
                    </v-flex>

                    <v-flex xs6 offset-xs1>
                        <v-subheader class="pa-0">Категория в Iiko</v-subheader>
                        <v-autocomplete
                            v-model="iiko_delivery.category"
                            :items="iiko_items"
                            :disabled="iiko_delivery.isLoading"
                            :loading="iiko_delivery.isLoading"
                            :search-input.sync="iiko_delivery.categorySearch"
                            color="black"
                            @change="changeIikoDeliveryCategory"
                            @click:clear="clearIikoDeliveryProducts"
                            single-line
                            solo
                            hide-no-data
                            hide-selected
                            item-text="name"
                            item-value="id"
                            clearable
                            :placeholder="iiko_delivery.isLoading ? 'Пожалуйста подождите, список подготавливается' : 'Поиск категории по названию'"
                            return-object
                        ></v-autocomplete>

                        <template v-if="iiko_delivery.category && itemsDelivery && itemsDelivery.length">
                            <v-subheader class="pa-0">Получение ID продукта из Iiko</v-subheader>
                            <v-autocomplete
                                v-model="iiko_delivery.product"
                                :items="itemsDelivery"
                                :search-input.sync="iiko_delivery.search"
                                color="black"
                                @change="changeIikoDeliveryId"
                                class="mt-5 mb-5"
                                single-line
                                solo
                                hide-no-data
                                hide-selected
                                item-text="name"
                                item-value="id"
                                clearable
                                placeholder="Поиск продукта по названию из выбранной категории"
                                return-object
                            ></v-autocomplete>
                        </template>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-flex xs12>
                <v-layout>
                    <upload-img :image-width="1024" :image-height="1024" v-model="product.img[c - 1]" v-for="c in 3"
                                :key="c">
                        <div slot="activator">
                            <v-avatar size="170px" v-ripple class="grey lighten-3" tile v-if="!product.img[c - 1]">
                                <img src="/static/img/media/image_blank.svg"
                                     alt="Нажмите чтобы добавить картинку для продукта"/>
                            </v-avatar>
                            <v-avatar size="170px" v-ripple tile v-else>
                                <img :src="product.img[c - 1].imageURL" alt="Изображение для продукта"/>
                            </v-avatar>
                        </div>
                    </upload-img>
                </v-layout>
            </v-flex>

            <v-flex xs12>
                <v-layout>
                    <v-flex xs4>
                        <v-checkbox label="Новинка" v-model="product.new"/>
                        <v-checkbox label="Популярный" v-model="product.popular"/>
                    </v-flex>

                    <v-flex xs4>
                        <v-checkbox label="Хит" v-model="product.hit"/>
                        <v-checkbox :label="product.status ? 'Включен' : 'Отключен'" v-model="product.status"/>
                    </v-flex>

                    <v-flex xs4>
                        <v-checkbox label="Включить синхронизацию" v-model="product.enable_sync"/>
                        <v-checkbox :label="attr.key" v-for="attr in product.attrs" :key="attr.id"
                                    v-model="attr.status"/>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-flex xs12>
                <v-layout>
                    <v-flex xs2>
                        <v-subheader class="pa-0">Позиция</v-subheader>
                        <v-text-field
                            ref="product_position"
                            v-model="product.position"
                            v-validate="'required'"
                            data-vv-name="position"
                            :error-messages="errors.collect('position')"
                            single-line
                            text
                            solo
                            required/>
                    </v-flex>

                    <v-spacer/>

                    <v-flex xs9>
                        <v-subheader class="pa-0">Описание</v-subheader>
                        <v-textarea
                            ref="category_description"
                            v-model="product.description"
                            v-validate="'required|max:255'"
                            :error-messages="errors.collect('description')"
                            data-vv-name="description"
                            single-line
                            text
                            solo
                            required
                            counter="255"/>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-form>
    </v-layout>
</template>

<script>
import UploadImg from '../../../../components/Media/Upload'
import Product from '../../../../api/product'
import Attr from '../../../../api/attr'
import {mapState} from 'vuex'

export default {
    name: 'addProduct',
    $_veeValidate: {
        validator: 'new'
    },
    components: {UploadImg},
    data: () => ({
        loading: false,
        iiko: {
            isLoading: false,
            product: null,
            category: null,
            categorySearch: '',
            search: '',
        },

        iiko_delivery: {
            isLoading: false,
            product: null,
            category: null,
            categorySearch: '',
            search: '',
        },

        project: null,
        product: {
            img: [],
            name: '',
            new: true,
            hit: false,
            price: null,
            position: 1,
            discount: 0,
            enable_sync: true,
            status: true,
            popular: false,
            category_id: 0,
            description: '',
            attrs: [],
            variants: [],

            iiko_delivery_append: true,
            iiko_delivery_id: null,
        },
        addVariant: false,
        dictionary: {
            custom: {
                name: {
                    required: 'Введите название для продукта',
                    max: 'Превышено максимальное количество символов в названии'
                },
                price: {
                    required: 'Цена не указано'
                },
                description: {
                    required: 'Описание не заполнено',
                    max: 'Превышено максимальное количество символов в описании'
                },
                position: {
                    required: 'Позиция не указана'
                }
            }
        }
    }),

    watch: {
        'iiko.categorySearch': function (val) {
            if (this.iiko_items.length) return
            this.getIikoCategoryProducts()
        },

        'iiko_delivery.categorySearch': function (val) {
            if (this.iiko_items.length) return
            this.getIikoCategoryProducts()
        },
    },

    computed: {
        ...mapState({
            iiko_items: state => state.Product.iiko_catalogue
        }),

        items() {
            if (this.iiko.category) {
                return this.iiko.category.products
            }
            return []
        },

        itemsDelivery() {
            if (this.iiko_delivery.category) {
                return this.iiko_delivery.category.products
            }
            return []
        },
    },

    created() {
        let user = sessionStorage.getItem('user')
        if (user) {
            let userObject = JSON.parse(user)
            if (userObject) {
                this.project = userObject.data.project
            }
        }
    },

    mounted() {
        this.$validator.localize('ru', this.dictionary)

        Attr
            .getByCategory(this.$route.query.categoryId)
            .then(response => {
                this.product.attrs = response.data.data

                for (let i = 0; i < this.product.attrs.length; i++) {
                    this.product.attrs[i].status = false
                    delete this.product.attrs[i].values
                }
            })
            .catch(error => new Error(error))
    },

    methods: {
        changeIikoId(val) {
            if (val) {
                this.product.iiko_id = val.id
                this.product.name = val.name
                this.product.price = parseInt(val.sizePrices[0].price.currentPrice)
                if (val.sizePrices && val.sizePrices.length) {
                    this.product.price = parseInt(val.sizePrices[0].price.currentPrice)
                }
            }
        },

        changeIikoDeliveryId(val) {
            if (val) {
                this.product.iiko_delivery_id = val.id
                if (val.sizePrices && val.sizePrices.length) {
                    this.product.iiko_delivery_price = parseInt(val.sizePrices[0].price.currentPrice)
                }
            }
        },

        changeIikoCategory(val) {
            if (val) {
                this.iiko.category = val
            }
        },

        clearIikoProducts() {
            this.iiko.category = {
                id: null,
                products: [],
            }
        },

        changeIikoDeliveryCategory(val) {
            if (val) {
                this.iiko_delivery.category = val
            }
        },

        clearIikoDeliveryProducts() {
            this.iiko_delivery.category = {
                id: null,
                products: [],
            }
        },

        // async getIikoProducts () {
        //     this.iiko.isLoading = true
        //     try {
        //         let { data } = await Product.getIikoProducts()
        //         this.iiko_items = data
        //     } catch (e) {
        //
        //     } finally {
        //         this.iiko.isLoading = false
        //     }
        // },

        async getIikoCategoryProducts() {
            this.iiko.isLoading = true
            this.iiko_delivery.isLoading = true

            try {
                let {data} = await Product.getIikoCategoryProducts()
                this.$store.commit('storeIikoProducts', data)
            } catch (e) {

            } finally {
                this.iiko.isLoading = false
                this.iiko_delivery.isLoading = false
            }
        },

        sendForm() {
            this.$validator
                .validateAll()
                .then(isValid => {
                    if (!isValid) return

                    this.product.category_id = this.$route.query.categoryId
                    this.loading = true

                    Product
                        .create(this.product)
                        .then(response => {
                            this.$store.commit('showSnackbar', {
                                text: 'Успех! Продукт добавлен',
                                color: 'success'
                            })
                            this.$store.commit('addProduct', response.data)
                            this.$router.push({name: 'categoryRoot'})
                        })
                        .catch(error => this.$store.commit('showSnackbar', {text: error.response.data.error[Object.keys(error.response.data.error)[0]][0]}))
                        .finally(() => this.loading = false)
                })
                .catch(error => new Error(error))
        }
    }
}
</script>
